/** PortalAccessContext: fetches the model's access flags once and exposes them. */
import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { apiGet } from "../api/client";

const DEFAULTS = {
  tronc_commun: true,
  complementary_modules: [],
  under_management: false,
};

const PortalAccessContext = createContext({
  access: DEFAULTS,
  loading: true,
  reload: () => {},
});

export const PortalAccessProvider = ({ children }) => {
  const [access, setAccess] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const data = await apiGet("/api/portal/access");
      setAccess(data);
    } catch {
      setAccess(DEFAULTS);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const value = useMemo(
    () => ({ access, loading, reload }),
    [access, loading, reload],
  );

  return (
    <PortalAccessContext.Provider value={value}>
      {children}
    </PortalAccessContext.Provider>
  );
};

export const usePortalAccess = () => useContext(PortalAccessContext);
